import { render, staticRenderFns } from "./CollectionTabs.vue?vue&type=template&id=0c550276&scoped=true"
import script from "./CollectionTabs.vue?vue&type=script&lang=js"
export * from "./CollectionTabs.vue?vue&type=script&lang=js"
import style0 from "./CollectionTabs.vue?vue&type=style&index=0&id=0c550276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c550276",
  null
  
)

export default component.exports